import { Maximize2, Minimize2 } from 'lucide-react'
import React from 'react'

import styles from './styles.module.scss'

type MapControlsProps = {
  canZoomIn: boolean
  canZoomOut: boolean
  canFullscreen: boolean
  isFullscreen: boolean
  onReset: () => void
  onToggleFullscreen: () => void
  onZoomIn: () => void
  onZoomOut: () => void
}

const MapControls = ({
  canZoomIn,
  canZoomOut,
  canFullscreen,
  isFullscreen,
  onReset,
  onToggleFullscreen,
  onZoomIn,
  onZoomOut,
}: MapControlsProps) => (
  <div className={styles.mapControls} aria-label="Map zoom controls">
    <button type="button" aria-label="Zoom map in" disabled={!canZoomIn} onClick={onZoomIn}>
      +
    </button>
    <button type="button" aria-label="Zoom map out" disabled={!canZoomOut} onClick={onZoomOut}>
      −
    </button>
    <button type="button" className={styles.resetView} onClick={onReset}>
      Reset
    </button>
    {canFullscreen ? (
      <button
        type="button"
        className={styles.fullscreenToggle}
        aria-label={isFullscreen ? 'Exit full screen map' : 'Expand map to full screen'}
        onClick={onToggleFullscreen}
      >
        {isFullscreen ? <Minimize2 size={18} aria-hidden /> : <Maximize2 size={18} aria-hidden />}
      </button>
    ) : null}
  </div>
)

export default MapControls
